import type { LandingPageContent } from '../types'

export const FOTOWOLTAIKA_POMPA_CIEPLA: LandingPageContent = {
  slug: 'fotowoltaika-pompa-ciepla',
  lang: 'pl',
  topicId: 'photovoltaik-waermepumpe',
  title: 'Fotowoltaika i pompa ciepła: porównaj oferty niezależnie',
  metaDescription:
    'Zaplanuj pompę ciepła i instalację fotowoltaiczną razem: porównaj bezpłatnie oferty ' +
    'zweryfikowanych firm, bez lawiny telefonów - dla obu projektów osobno lub razem.',
  keywords: [
    'fotowoltaika pompa ciepła',
    'panele fotowoltaiczne dla pompy ciepła',
    'pompa ciepła fotowoltaika',
    'zużycie prądu pompa ciepła',
    'fotowoltaika wallbox pompa ciepła',
  ],
  eyebrow: 'Pompa ciepła + fotowoltaika',
  h1: 'Fotowoltaika i pompa ciepła: porównaj oferty niezależnie',
  intro:
    'Pompa ciepła to zdecydowanie największy odbiorca prądu w domu - a instalacja fotowoltaiczna ' +
    'dostarcza dokładnie taki tani prąd z własnego dachu. W Roofora możecie Państwo złożyć oba ' +
    'zapytania jako osobne, anonimowe zgłoszenia i niezależnie porównać oferty zweryfikowanych firm ' +
    'instalatorskich - bezpłatnie, bez lawiny telefonów, z ujawnieniem kontaktu dopiero po Państwa zgodzie.',
  sections: [
    { type: 'heading', text: 'Dlaczego fotowoltaika i pompa ciepła do siebie pasują' },
    {
      type: 'paragraph',
      text:
        'Pompa ciepła zamienia prąd na wielokrotnie większą ilość ciepła - to, czy ten prąd pochodzi ' +
        'z sieci czy z własnego dachu, nie zmienia mocy grzewczej, ale wyraźnie zmienia koszt ' +
        'kilowatogodziny ciepła. Jeśli pompa ciepła pracuje (automatycznie lub ręcznie) najchętniej ' +
        'wtedy, gdy instalacja fotowoltaiczna produkuje dużo prądu, udział autokonsumpcji wyraźnie ' +
        'rośnie - zamiast oddawać południową nadwyżkę do sieci za niewielkie pieniądze, a wieczorem ' +
        'odkupywać drogi prąd sieciowy.',
    },
    { type: 'heading', text: 'Dwa osobne zapytania, jedno wspólne planowanie' },
    {
      type: 'list',
      items: [
        'Fotowoltaika jako osobne zapytanie: system kompletny, sam montaż na dachu lub tylko instalacja elektryczna',
        'Pompa ciepła jako osobny rodzaj zlecenia, niezależnie od tego, czy mają już Państwo instalację fotowoltaiczną',
        'Oba zapytania anonimowe - firmy instalatorskie składają niewiążące oferty z ceną stałą bez konieczności podawania danych kontaktowych',
        'Kontakt powstaje dopiero, gdy indywidualnie zaakceptują Państwo konkretną firmę - bez zbiorowej zgody, bez lawiny telefonów',
      ],
    },
    { type: 'heading', text: 'Na co zwrócić uwagę przy łączeniu obu systemów' },
    {
      type: 'list',
      items: [
        'Dobierz wielkość instalacji do rzeczywistego zapotrzebowania: roczne zużycie prądu z pompą ciepła powinno wejść do obliczenia wielkości instalacji, nie tylko dotychczasowe zużycie domowe',
        'Sprawdź zasobnik buforowy: odpowiednio duży zasobnik pozwala magazynować nadwyżkę fotowoltaiczną "termicznie"',
        'Zwróć uwagę na temperaturę zasilania: ogrzewanie podłogowe pozwala na niższe temperatury zasilania, a tym samym na wydajniejszą pompę ciepła niż klasyczne grzejniki',
        'Zaplanuj kolejność: jeśli instalacja fotowoltaiczna zostanie dobrana bez uwzględnienia planowanej później pompy ciepła, później często okazuje się za mała dla nowego zużycia',
      ],
    },
  ],
  faq: [
    {
      q: 'Czy muszę zgłaszać fotowoltaikę i pompę ciepła w Roofora razem?',
      a: 'Nie - to dwa osobne rodzaje zapytań, które można złożyć niezależnie od siebie. Dla realistycznej wielkości instalacji warto jednak podać dodatkowe zużycie przez pompę ciepła w zapytaniu fotowoltaicznym.',
    },
    {
      q: 'O ile pompa ciepła zwiększa zużycie prądu?',
      a: 'To mocno zależy od budynku, obciążenia cieplnego i sprawności pompy ciepła - podawanie ogólnej liczby nie byłoby rzetelne. Firmy instalatorskie mogą to realistycznie oszacować na podstawie Państwa danych o dotychczasowym ogrzewaniu.',
    },
    {
      q: 'Czy mogę zobaczyć orientacyjny koszt instalacji fotowoltaicznej przed złożeniem zapytania?',
      a: 'Tak - w kalkulatorze cen otrzymają Państwo wartość orientacyjną wyłącznie dla instalacji fotowoltaicznej, na podstawie rzeczywistych ofert. Kalkulator nie uwzględnia dopłaty specyficznej dla pompy ciepła, ponieważ nie istnieje dla niej wiarygodna baza danych.',
    },
    {
      q: 'A jeśli chcę zgłosić tylko pompę ciepła, bez fotowoltaiki?',
      a: 'Bez problemu - rodzaj zlecenia "pompa ciepła" można wykorzystać niezależnie od instalacji fotowoltaicznej.',
    },
  ],
  primaryCta: { label: 'Złóż zapytanie o pompę ciepła', action: 'customer' },
  secondaryCta: { label: 'Jak obliczamy cenę orientacyjną', action: 'link', href: '/jak-obliczamy-cene' },
  relatedLinks: [
    { label: 'Ile kosztuje instalacja solarna?', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
  ],
}
